import React, {ReactNode} from "react";

interface CardHolderProps {
    onClick?: () => void;
    title: string;
    children: ReactNode;
}
const CardHolder = (props: CardHolderProps) => (
    <div
        className={"p-4 rounded-2xl relative border w-full border-gray-50 shadow-xl bg-white flex flex-col justify-center justify-items-stretch items-stretch"}
        role="button"
        onClick={props.onClick}
    >
        <span className={"text-xl text-center pb-4 mb-4 border-b border-solid border-gray-200"}>{props.title || " "}</span>
        <span className={"text-xl text-center pb-4 mb-4 flex-grow h-full flex flex-col justify-center"}>{props.children}</span>
    </div>
);
export default CardHolder;
